import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductService } from '../../services/product/product.service';
import { ProductListing } from '../../types/product.type';
import { environment } from '../../../../environments/environment';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Utilities } from '../../utilities/utilities';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { ListingsRoute } from '../../types/strings.type';
import { StringsService } from '../../services/strings/strings.service';
import { ErrorService } from '../../services/errors/error.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'rttd-listings',
    templateUrl: './listings.component.html',
    styles: [
        require('./listings.component.scss').default.toString(),
        require(`./listings.component.${environment.brand}.scss`).default.toString()
    ],
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*'
            })),
            state('closed', style({
                height: '0px'
            })),
            transition('open => closed', [
                animate(300)
            ]),
            transition('closed => open', [
                animate(300)
            ])
        ])
    ]
})
export class ListingsComponent implements OnInit, OnDestroy {

    @Input() modelFilter: string;

    products: Array<ProductListing>;

    hasParent = false;
    windowWidth: any;
    contact: string;
    content: ListingsRoute;
    footerShift = false;
    isEvent: boolean = this.appSettings.eventJourney;
    productServiceSubscription: Subscription;

    constructor(
        private productService: ProductService,
        private utilities: Utilities,
        private appSettings: AppSettings,
        private stringsService: StringsService,
        private errorService: ErrorService) {
    }

    ngOnInit() {
        this.contact = this.appSettings.retailerContactUsPageUrl;
        this.windowWidth = window.innerWidth;
        this.productServiceSubscription = this.productService.getListings().subscribe((data: Array<ProductListing>) => {
            if (this.modelFilter) {
                this.products = data.filter(x => x.name == this.modelFilter);
            } else {
                this.hasParent = !!data[0].simpleName;
                this.products = data;
            }

            if (environment.brand.toLowerCase() == "mini")
            {
                var modelSortList = ['New Countryman', 'Electric', '3-Door Hatch', '5-Door Hatch', 'Convertible', 'Clubman', 'John Cooper Works'];
                this.products[0].items.sort(function (a,b){
                    return modelSortList.indexOf(a.name) - modelSortList.indexOf(b.name)
                });
            }
        });
        this.stringsService.get().subscribe((data: ListingsRoute) => {
            this.content = data['ListingsRoute'];
        });
    }

    ngOnDestroy() {
        if (this.productServiceSubscription) {
            this.productServiceSubscription.unsubscribe();
        }
    }

    @HostListener('window:resize')
    onResize() {
        this.windowWidth = window.innerWidth;
    }

    openAllProducts() {
        if (this.windowWidth >= this.utilities.deviceSizes('medium')) {
            this.products.map((item) => {
                item.isOpen = true;
            });
        } else {
            this.products.map((item) => {
                item.isOpen = false;
            });
            this.products[0].isOpen = true;
        }
    }

    toggleProducts(product, $event) {
        if (product.isOpen) {
            this.closeAllProducts();
        } else {
            this.closeAllProducts();
            product.isOpen = true;
        }

        if (this.windowWidth <= this.utilities.deviceSizes('medium')) {
            setTimeout(() => {
                if ($event.target) {
                    $event.target.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                }
            }, 500);
        } else {
            this.toggleMargin(product.isOpen);
        }
    }

    toggleMargin(open) {
        this.footerShift = !!(this.windowWidth >= this.utilities.deviceSizes('medium') && open);
    }


    closeAllProducts() {
        this.products.forEach((item) => {
            item.isOpen = false;
        });
    }

}
